import { render, staticRenderFns } from "./news2.vue?vue&type=template&id=7633058d&"
import script from "./news2.vue?vue&type=script&lang=js&"
export * from "./news2.vue?vue&type=script&lang=js&"
import style0 from "./news2.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports